<template>
    <div :class="{ 'has-logo': showLogo }">
        <!-- <logo v-if="showLogo" :collapse="isCollapse" /> -->
        <!-- <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="true"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in hz_router"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar> -->
        <div class="barCont" :style="{ width: isCollapse ? '240px' : '100px' }">
            <div class="menu">
                <div v-for="(menu, index) in hz_router" v-if="!menu.hidden" :key="index" :class="path == menu.path ? 'menuItem active' : 'menuItem'" @click="showSubmenu(menu.path)">
                    <div class="imgCont">
                        <img :src="menu.meta.icon" alt="" />
                    </div>
                    <div class="menuText">{{ menu.name }}</div>
                    <!-- <div class="shouqi"></div> -->
                </div>
            </div>
            <div v-show="isCollapse" class="submenu">
                <div v-for="(item, index) in subMenuList" v-if="item.hidden == 0" :key="index" :class="item.path == activeMenu ? 'active submenu-item' : 'submenu-item'" @click="goRouter(item.path)">
                    <div>{{ item.name }}</div>
                </div>
            </div>

            <div :class="isCollapse ? 'zhankai' : 'zhankai leftpx'" @click="hideSubmenu">
                <i v-show="isCollapse" class="el-icon-arrow-left" />
                <i v-show="!isCollapse" class="el-icon-arrow-right" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Logo from './Logo';
import SidebarItem from './SidebarItem';
import variables from '@/styles/variables.scss';
import store from '@/store';
import Layout from '@/views/layout';
import { getBasicUserTypeListReq } from '@/axios/common';
export default {
    components: { SidebarItem, Logo },
    data() {
        return {
            hz_router: [],
            submenuFlag: false,
            currentSubMenu: [],
            path: '',
            timeId: null,
        };
    },
    created() {
        const route = this.$route;
        const { matched } = route;
        this.path = matched[0].path;
    },
    computed: {
        ...mapGetters(['permission_routes', 'sidebar']),
        activeMenu() {
            const route = this.$route;
            const { meta, path } = route;
            // if set path, the sidebar will highlight the path you set
            if (meta.activeMenu) {
                return meta.activeMenu;
            }
            return path;
        },
        subMenuList() {
            let arr = [];

            this.hz_router.forEach((item) => {
                if (item.path == this.path) {
                    arr = item.children;
                }
            });

            if (!arr.length) {
                this.$store.dispatch('app/toggleSideBar', 0);
            } else {
                this.$store.dispatch('app/toggleSideBar', 1);
            }
            return arr;
        },
        showLogo() {
            return this.$store.state.settings.sidebarLogo;
        },
        variables() {
            return variables;
        },
        isCollapse() {
            return this.sidebar.opened;
        },
    },
    watch: {
        $route: {
            handler: function (val, oldVal) {
                const { matched } = this.$route;
                this.path = matched[0].path;

                // this.path = val.path
            },
            // 深度观察监听
            deep: true,
        },
    },

    mounted() {
        this.clearIntervalHideMenu();
        this.hzRouter();
        this.hideMenuSetInterval();
        this.getBasicUserTypeList();
    },
    destroyed() {
        this.clearIntervalHideMenu();
    },
    methods: {
        //请求客户类型
        async getBasicUserTypeList() {
            const res = await getBasicUserTypeListReq({
                status: 1,
                page: 1,
                pageSize: 50,
            });
            if (res.code == 200) {
                // 使用 map 转换数据格式以匹配 gradeRankOptions 的结构
                const options = res.data.data.map((item) => ({
                    label: item.name,
                    value: item.id,
                }));

                // 提交到 store 更新 gradeRankOptions
                this.$store.commit('rankList/SET_GRADE_RANK_OPTIONS', options);
            }
        },
        // ...common.mapMutations(['SET_ISCOLLAPSE']),
        hideMenuSetInterval() {
            // this.timeId = setInterval(() => {
            //   this.$store.dispatch("app/toggleSideBar", 0);
            //   this.clearIntervalHideMenu()
            // }, 9000)
        },
        clearIntervalHideMenu() {
            clearInterval(this.timeId);
        },
        async hzRouter() {
            const { hzrouter } = await store.dispatch('user/getInfo');
            let routerList = [];
            if (hzrouter.length === 0) return;
            hzrouter.forEach((item) => {
                item.children.forEach((citem) => {
                    let childrenList = [];
                    // let obj = {
                    //   path: citem.URL,
                    //   name: citem.NAME,
                    //   meta: {
                    //     title: citem.NAME
                    //   },
                    //   component: (resolve) =>
                    //     require(['@/views' + citem.URL + '.vue'], resolve)
                    // }
                    if (citem.children.length > 0 && !citem.URL.includes('Out')) {
                        citem.children.forEach((ccitem) => {
                            let cobj = {
                                path: '/' + ccitem.TAG_NAME,
                                name: ccitem.NAME,
                                meta: {
                                    title: ccitem.NAME,
                                },
                                hidden: ccitem.HIDDEN,
                                component: (resolve) => require(['@/views' + ccitem.URL + '.vue'], resolve),
                                // component: () => import('@/views/'+ccitem.URL)
                            };
                            childrenList.push(cobj);
                        });
                        routerList.push({
                            path: citem.URL,
                            name: citem.NAME,
                            component: Layout,
                            children: childrenList,
                            alwaysShow: citem.SHOW,
                            meta: {
                                title: citem.NAME,
                                icon: citem.ICON,
                            },
                        });
                    }
                });
            });
            this.hz_router = routerList;
        },

        goRouter(data) {
            this.clearIntervalHideMenu();
            this.$router.push(data);
            this.hideMenuSetInterval();
        },
        showSubmenu(url) {
            this.clearIntervalHideMenu();
            this.path = url;
            // this.submenuFlag = true
            this.$store.dispatch('app/toggleSideBar', 1);
            this.hideMenuSetInterval();
        },
        hideSubmenu() {
            this.clearIntervalHideMenu();
            if (this.isCollapse) {
                this.$store.dispatch('app/toggleSideBar', 0);
            } else {
                this.$store.dispatch('app/toggleSideBar', 1);
                this.hideMenuSetInterval();
            }
            // this.submenuFlag = false
        },
    },
};
</script>
<style lang="scss">
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

::-webkit-scrollbar-track {
    // background: #163361;
    // border-radius: 3px;
    background-color: #edf0f2;
}

/* 滚动条色 */
::-webkit-scrollbar-thumb {
    background: #ccc;
    // border-radius: 3px;
}

.el-scrollbar__wrap {
    overflow-x: hidden;
}

.sidebar {
    position: fixed;
    left: 0;
    top: 0;
    padding-top: 50px;
    height: 100%;
    // background-color: rgb(48, 65, 86);
    // background-color: rgb(48, 65, 86);
    // box-shadow: 2px 0px 7px 1px rgba(152,152,152,0.1000);
}

// .logo{
//     width: 100%;
//     line-height: 50px;
//     background-color: #fff;
//     text-align: center;
//     height:50px;
// }
// .el-submenu__title:hover{
//     background-color: rgb(64, 158, 255) !important;
// }
.barCont {
    height: 100%;

    position: relative;
    box-sizing: border-box;

    .zhankai {
        cursor: pointer;
        z-index: 300;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 50%;
        right: 0px;
        width: 10px;
        height: 50px;
        margin-top: -20px;
        background: #cccccc;
        border-radius: 0 10px 10px 0;
        border: 1px solid #ebebeb;
        border-left: none;
        transition: background 0.2s;

        i {
            font-size: 12px;
            color: #fff;
        }

        &:hover {
            background: #2dafeb;
        }
    }

    .leftpx {
        right: -10px;
    }

    .submenu {
        position: absolute;
        padding: 16px 8px;
        left: 100px;
        top: 0;
        z-index: 10px;
        width: 130px;
        height: 100%;
        background-color: #f7f7f7;
        border-right: 1px solid #e6e6e6;

        .submenu-item {
            font-size: 14px;
            color: #4d4d4d;
            padding: 10px 7px;
            margin-bottom: 10px;
            border: 1px solid #f7f7f7;
            cursor: pointer;
            transition: all 0.1s;

            &:hover {
                color: #2dafeb;
                background: #f7f7f7;
                border: 1px solid #ccc;
                border-radius: 4px;
            }
        }

        .active {
            color: #2dafeb;
            background: #f7f7f7;
            border-color: #ccc;
            border-radius: 4px;
        }
    }

    .menu {
        width: 100px;
        background-color: #fff;
        padding: 13px 10px;
        height: 100%;
        overflow-y: auto;
        box-sizing: border-box;
        box-shadow: 2px 0px 7px 1px rgba(152, 152, 152, 0.1);

        .menuItem {
            text-align: center;
            padding-top: 28px;
            box-sizing: border-box;
            padding-bottom: 12px;
            box-sizing: border-box;
            cursor: pointer;
            border: 1px solid #fff;
            position: relative;

            // margin-bottom: 10px;
            .shouqi {
                cursor: pointer;
                z-index: 300;
                position: absolute;
                display: flex;
                align-items: center;
                justify-content: center;
                top: 28px;
                right: -35px;
                width: 20px;
                height: 40px;

                background: #f7f7f7;
                border-radius: 0 4px 4px 0;
                border: 1px solid #ebebeb;
                border-left: none;

                i {
                    font-size: 12px;
                    color: #ccc;
                }
            }

            &:hover {
                background-color: #f7f7f7;
                border-color: #e6e6e6;
            }

            .imgCont {
                width: 26px;
                height: 26px;
                margin: 0 auto;

                img {
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            }

            .menuText {
                font-size: 14px;
                margin-top: 15px;
                color: #4d4d4d;
            }
        }

        .active {
            background-color: #f7f7f7;
            border-color: #e6e6e6;
        }
    }
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 210px;
    min-height: 100%;
}

.el-menu-item.is-active {
    background-color: rgb(38, 52, 69) !important;
    color: #fff;

    span {
        color: #fff !important;
    }
}
</style>
